import useMutationApi from 'src/api/useMutationApi';
import {
  EmailIngestConfig,
  EMAIL_INGEST_QUERY_KEY,
} from './useEmailIngestConfig';
import { useQueryClient } from '@tanstack/react-query';

export interface UpdateEmailIngestConfigRequest {
  enabled?: boolean;
  tenantId?: string | null;
  clientId?: string | null;
  clientSecret?: string | null;
  mailboxUpns?: string[];
}

interface UpdateEmailIngestConfigResponse {
  emailIngestConfig: EmailIngestConfig;
}

const useUpdateEmailIngestConfig = () => {
  const queryClient = useQueryClient();
  return useMutationApi<
    UpdateEmailIngestConfigRequest,
    UpdateEmailIngestConfigResponse,
    UpdateEmailIngestConfigResponse
  >({
    endpoint: EMAIL_INGEST_QUERY_KEY,
    method: 'POST',
    successMessage: 'Email ingestion configuration updated successfully',
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [EMAIL_INGEST_QUERY_KEY] });
      },
    },
  });
};

export default useUpdateEmailIngestConfig;
